import LocalizedStrings from 'react-localization';
import Axios from 'axios';
import { EventEmitter } from 'events';
import { ILocStrings, ILocalization } from './localization-interface';
import { defaultLocalization } from './default-localization';
import { DebuggerInstance } from '../debugger';

export interface ILanguage {
    langId: number;
    name: string;
    nativeName: string;
    isO2Code: string;
    isO3Code: string;
}

export let localization: ILocStrings = new LocalizedStrings({
    default: defaultLocalization
})

/**
 * name of event raised when language is changed
 */
export const langChangedName: string = 'lang';

/**
 * Helper for managing global variable localization
 */
class LocHelper {
    private serverLanguages: ILanguage[] = [];

    public langChanged: EventEmitter = new EventEmitter();
    public initialized: boolean = false;

    public async initialize(lang: string | null) {
        if (this.initialized) {
            return;
        }

        DebuggerInstance.log('initialize language');
        this.initialized = true;

        this.langChanged.setMaxListeners(200);

        if (lang == null) {
            // potreba konverze na en, cs, ...
            const langInterface = localization.getInterfaceLanguage();
            lang = langInterface.substr(0, 2); // en-us => en
        }

        this.serverLanguages = await this.getServerLanguages();

        await this.setLang(lang);
    }

    private async getServerLanguages(): Promise<ILanguage[]> {
        const response = await Axios.get<ILanguage[]>(`/api/localization/languages`);

        DebuggerInstance.log('getServerLanguages');
        DebuggerInstance.log(response);

        return response.data;
    }

    public async setLang(lang: string) {
        lang = lang.toUpperCase();
        DebuggerInstance.log('LocHelper.setLang');
        DebuggerInstance.log(lang);

        const loadedLang = localization.getAvailableLanguages();
        DebuggerInstance.log(loadedLang);

        const index = loadedLang.indexOf(lang);
        if (index >= 0) {
            // jazyk je uz nacteny
            this.setLangInternal(lang);
            return;
        }

        // if requested lang is not loaded -> check if it is available on server
        const isAvailable = this.serverLanguages.filter(l => l.isO2Code === lang);
        if (isAvailable.length === 0) {
            this.setLangInternal('default');
            return;
        }

        const langResponse = await Axios.get<ILocalization>(`/api/localization/${lang}.json`);
        DebuggerInstance.log('langResponse');
        DebuggerInstance.log(langResponse);

        // merge with new lang
        const currentContent = (localization as any).getContent();
        DebuggerInstance.log(currentContent);
        currentContent[lang] = langResponse.data;
        localization = new LocalizedStrings(currentContent);
        DebuggerInstance.log(currentContent);

        localization.setContent(currentContent);
        DebuggerInstance.log('Available languages after load');
        DebuggerInstance.log(localization.getAvailableLanguages());

        this.setLangInternal(lang);
    }

    private setLangInternal(lang: string): void {
        localization.setLanguage(lang);
        this.langChanged.emit(langChangedName);
    }

    public getLanguages(): ILanguage[] {
        return this.serverLanguages;
    }

    public getCurrentLanguage(): string | null {
        const lang = localization.getLanguage();
        return lang === 'default' ? null : lang;
    }

    public async getVisualizationProcessDescription(apiKey: string) : Promise<string> {
        try {
            const currLang = this.getCurrentLanguage();
            const response = await Axios.get<string>(`/api/${apiKey}/customization/visualization-process-description/${currLang}`);
            return response.data;
        } catch {
            return localization.editorLoc.logoEditorContent.proofreading.infoText;
        }
    }
}

export const LocHelperInstance: LocHelper = new LocHelper();



// WEBPACK FOOTER //
// ./src/App/shared/localization/localization.tsx